export const ME_QUERY = `
  query Me {
    me {
      authenticated
      deviceId
      authMethod
      sensitiveAccessGranted
      user {
        id
        email
        displayName
        role
        preferences
      }
    }
  }
`;

export const LOGIN_MUTATION = `
  mutation Login($input: LoginInput!) {
    login(input: $input) {
      authenticated
      deviceId
      authMethod
      sensitiveAccessGranted
      user {
        id
        email
        displayName
        role
        preferences
      }
    }
  }
`;

export const LOGIN_WITH_PIN_MUTATION = `
  mutation LoginWithPin($input: LoginWithPinInput!) {
    loginWithPin(input: $input) {
      authenticated
      deviceId
      authMethod
      sensitiveAccessGranted
      user {
        id
        email
        displayName
        role
        preferences
      }
    }
  }
`;

export const REQUEST_PASSWORD_RESET_MUTATION = `
  mutation RequestPasswordReset($email: String!) {
    requestPasswordReset(email: $email)
  }
`;

export const PASSWORD_RESET_TOKEN_STATUS_QUERY = `
  query PasswordResetTokenStatus($token: String!) {
    passwordResetTokenStatus(token: $token) {
      valid
      email
      displayName
      expiresAt
      error
    }
  }
`;

export const RESET_PASSWORD_MUTATION = `
  mutation ResetPassword($token: String!, $password: String!) {
    resetPassword(token: $token, password: $password)
  }
`;

export const LOGOUT_MUTATION = `
  mutation Logout {
    logout
  }
`;

export const REVALIDATE_SESSION_MUTATION = `
  mutation RevalidateSession {
    revalidateSession {
      authenticated
      deviceId
      authMethod
      sensitiveAccessGranted
      user {
        id
        email
        displayName
        role
        preferences
      }
    }
  }
`;

export const AUTHORIZE_SENSITIVE_ACCESS_MUTATION = `
  mutation AuthorizeSensitiveAccess($password: String!) {
    authorizeSensitiveAccess(password: $password) {
      authenticated
      deviceId
      authMethod
      sensitiveAccessGranted
      user {
        id
        email
        displayName
        role
        preferences
      }
    }
  }
`;

export const BOOTSTRAP_QUERY = `
  query BootstrapState($scenarioName: String) {
    bootstrapState(scenarioName: $scenarioName) {
      session {
        authenticated
        deviceId
        authMethod
        sensitiveAccessGranted
        user {
          id
          email
          displayName
          role
          preferences
        }
      }
      scenarios {
        id
        name
        status
        isDefault
        currentVersion
        updatedAt
      }
      catalogVersion
      products {
        id
        name
        price
        categoryId
        categoryName
        categoryIsActive
        isActive
        catalogVersion
        createdAt
        updatedAt
      }
      scenario {
        id
        name
        status
        isDefault
        currentVersion
        updatedAt
        snapshot
      }
    }
  }
`;

export const PUSH_SCENARIO_SNAPSHOT_MUTATION = `
  mutation PushScenarioSnapshot($input: PushScenarioSnapshotInput!) {
    pushScenarioSnapshot(input: $input) {
      accepted
      catalogVersion
      products {
        id
        name
        price
        categoryId
        categoryName
        categoryIsActive
        isActive
        catalogVersion
        createdAt
        updatedAt
      }
      scenario {
        id
        name
        status
        isDefault
        currentVersion
        updatedAt
        snapshot
      }
    }
  }
`;

export const USERS_QUERY = `
  query Users {
    users {
      id
      email
      displayName
      isActive
      role
      preferences
      createdAt
      updatedAt
    }
  }
`;

export const CREATE_USER_MUTATION = `
  mutation CreateUser($input: CreateUserInput!) {
    createUser(input: $input) {
      id
      email
      displayName
      isActive
      role
      preferences
      createdAt
      updatedAt
    }
  }
`;

export const UPDATE_USER_MUTATION = `
  mutation UpdateUser($input: UpdateUserInput!) {
    updateUser(input: $input) {
      id
      email
      displayName
      isActive
      role
      preferences
      createdAt
      updatedAt
    }
  }
`;

export const SCENARIO_BASE_STATE_QUERY = `
  query ScenarioBaseState($scenarioName: String!) {
    scenarioBaseState(scenarioName: $scenarioName)
  }
`;

export const DELETE_USER_MUTATION = `
  mutation DeleteUser($id: ID!) {
    deleteUser(id: $id) {
      id
      email
      displayName
      isActive
      role
      preferences
      createdAt
      updatedAt
    }
  }
`;

export const UPDATE_PROFILE_MUTATION = `
  mutation UpdateProfile($input: UpdateProfileInput!) {
    updateProfile(input: $input) {
      id
      email
      displayName
      role
      preferences
    }
  }
`;

export const CREATE_PRODUCT_MUTATION = `
  mutation CreateProduct($input: CreateProductInput!) {
    createProduct(input: $input) {
      id
      name
      price
      categoryId
      categoryName
      categoryIsActive
      isActive
      catalogVersion
      createdAt
      updatedAt
    }
  }
`;

export const UPDATE_PRODUCT_MUTATION = `
  mutation UpdateProduct($input: UpdateProductInput!) {
    updateProduct(input: $input) {
      id
      name
      price
      categoryId
      categoryName
      categoryIsActive
      isActive
      catalogVersion
      createdAt
      updatedAt
    }
  }
`;

export const DELETE_PRODUCT_MUTATION = `
  mutation DeleteProduct($id: ID!) {
    deleteProduct(id: $id) {
      id
      name
      price
      categoryId
      categoryName
      categoryIsActive
      isActive
      catalogVersion
      createdAt
      updatedAt
    }
  }
`;

export const MANAGE_PRODUCTS_QUERY = `
  query ManageProducts {
    manageProducts {
      id
      name
      price
      categoryId
      categoryName
      categoryIsActive
      isActive
      catalogVersion
      createdAt
      updatedAt
    }
  }
`;

export const PRODUCTS_QUERY = `
  query Products {
    products {
      id
      name
      price
      categoryId
      categoryName
      categoryIsActive
      isActive
      catalogVersion
      createdAt
      updatedAt
    }
  }
`;

export const PRODUCT_CATEGORIES_QUERY = `
  query ProductCategories {
    productCategories {
      id
      name
      internalId
      isActive
      createdAt
      updatedAt
    }
  }
`;

export const CREATE_PRODUCT_CATEGORY_MUTATION = `
  mutation CreateProductCategory($input: CreateProductCategoryInput!) {
    createProductCategory(input: $input) {
      id
      name
      internalId
      isActive
      createdAt
      updatedAt
    }
  }
`;

export const UPDATE_PRODUCT_CATEGORY_MUTATION = `
  mutation UpdateProductCategory($input: UpdateProductCategoryInput!) {
    updateProductCategory(input: $input) {
      id
      name
      internalId
      isActive
      createdAt
      updatedAt
    }
  }
`;

export const DELETE_PRODUCT_CATEGORY_MUTATION = `
  mutation DeleteProductCategory($id: Int!) {
    deleteProductCategory(id: $id) {
      id
      name
      internalId
      isActive
      createdAt
      updatedAt
    }
  }
`;

export const LOGIN_USERS_QUERY = `
  query LoginUsers {
    loginUsers {
      email
      displayName
    }
  }
`;

export const UPDATE_USER_PREFERENCES_MUTATION = `
  mutation UpdateUserPreferences($input: UpdateUserPreferencesInput!) {
    updateUserPreferences(input: $input) {
      id
      email
      displayName
      role
      preferences
    }
  }
`;

export const SCENARIO_HISTORY_QUERY = `
  query ScenarioHistory($scenarioName: String!) {
    scenarioHistory(scenarioName: $scenarioName) {
      entries {
        id
        description
        snapshot
        tables
        walls
        triggeredByUserId
        triggeredByDeviceId
        createdAt
      }
      cursorEntryId
      cursorIndex
      canUndo
      canRedo
    }
  }
`;

const SCENARIO_HISTORY_MUTATION_FIELDS = `
  scenario {
    id
    name
    status
    isDefault
    currentVersion
    updatedAt
    snapshot
  }
  history {
    entries {
      id
      description
      snapshot
      tables
      walls
      triggeredByUserId
      triggeredByDeviceId
      createdAt
    }
    cursorEntryId
    cursorIndex
    canUndo
    canRedo
  }
`;

export const UNDO_SCENARIO_HISTORY_MUTATION = `
  mutation UndoScenarioHistory($scenarioName: String!) {
    undoScenarioHistory(scenarioName: $scenarioName) {
      ${SCENARIO_HISTORY_MUTATION_FIELDS}
    }
  }
`;

export const REDO_SCENARIO_HISTORY_MUTATION = `
  mutation RedoScenarioHistory($scenarioName: String!) {
    redoScenarioHistory(scenarioName: $scenarioName) {
      ${SCENARIO_HISTORY_MUTATION_FIELDS}
    }
  }
`;

export const UPDATE_SCENARIO_MUTATION = `
  mutation UpdateScenario($input: UpdateScenarioInput!) {
    updateScenario(input: $input) {
      id
      name
      status
      isDefault
      currentVersion
      updatedAt
      snapshot
    }
  }
`;

export const ARCHIVE_SCENARIO_MUTATION = `
  mutation ArchiveScenario($name: String!) {
    archiveScenario(name: $name) {
      id
      name
      status
      isDefault
      currentVersion
      updatedAt
      snapshot
    }
  }
`;

export const RESTORE_SCENARIO_MUTATION = `
  mutation RestoreScenario($name: String!) {
    restoreScenario(name: $name) {
      id
      name
      status
      isDefault
      currentVersion
      updatedAt
      snapshot
    }
  }
`;

export const SAVE_SCENARIO_BASE_STATE_MUTATION = `
  mutation SaveScenarioBaseState($name: String!) {
    saveScenarioBaseState(name: $name) {
      id
      name
      status
      isDefault
      currentVersion
      updatedAt
      snapshot
    }
  }
`;

export const DELETE_SCENARIO_MUTATION = `
  mutation DeleteScenario($name: String!) {
    deleteScenario(name: $name)
  }
`;

export const SCENARIO_LIBRARY_QUERY = `
  query ScenarioLibrary($status: String) {
    scenarioLibrary(status: $status) {
      id
      name
      status
      isDefault
      currentVersion
      updatedAt
    }
  }
`;

export const SCENARIO_EDIT_PRESENCE_QUERY = `
  query ScenarioEditPresence($scenarioName: String!) {
    scenarioEditPresence(scenarioName: $scenarioName) {
      scenarioName
      lockActive
      canEdit
      isEditor
      currentVersion
      activeViewerCount
      otherViewerCount
      collaborationActive
      canTakeOver
      canRequestAccess
      canApproveRequest
      requestPendingForCurrentUser
      readOnlyReason
      releasePending
      releasePendingForCurrentUser
      requestDeniedForCurrentUser
      requestDeniedReason
      heartbeatExpiresAt
      editor {
        userId
        displayName
        role
        deviceId
        isCurrentUser
      }
      returnTarget {
        userId
        displayName
        role
        deviceId
        isCurrentUser
      }
      request {
        requestedAt
        user {
          userId
          displayName
          role
          deviceId
          isCurrentUser
        }
      }
    }
  }
`;

export const ACQUIRE_SCENARIO_EDIT_LOCK_MUTATION = `
  mutation AcquireScenarioEditLock($scenarioName: String!, $force: Boolean) {
    acquireScenarioEditLock(scenarioName: $scenarioName, force: $force) {
      scenarioName
      lockActive
      canEdit
      isEditor
      currentVersion
      activeViewerCount
      otherViewerCount
      collaborationActive
      canTakeOver
      canRequestAccess
      canApproveRequest
      requestPendingForCurrentUser
      readOnlyReason
      releasePending
      releasePendingForCurrentUser
      requestDeniedForCurrentUser
      requestDeniedReason
      heartbeatExpiresAt
      editor {
        userId
        displayName
        role
        deviceId
        isCurrentUser
      }
      returnTarget {
        userId
        displayName
        role
        deviceId
        isCurrentUser
      }
      request {
        requestedAt
        user {
          userId
          displayName
          role
          deviceId
          isCurrentUser
        }
      }
    }
  }
`;

export const RENEW_SCENARIO_EDIT_LOCK_MUTATION = `
  mutation RenewScenarioEditLock($scenarioName: String!) {
    renewScenarioEditLock(scenarioName: $scenarioName) {
      scenarioName
      lockActive
      canEdit
      isEditor
      currentVersion
      activeViewerCount
      otherViewerCount
      collaborationActive
      canTakeOver
      canRequestAccess
      canApproveRequest
      requestPendingForCurrentUser
      readOnlyReason
      releasePending
      releasePendingForCurrentUser
      requestDeniedForCurrentUser
      requestDeniedReason
      heartbeatExpiresAt
      editor {
        userId
        displayName
        role
        deviceId
        isCurrentUser
      }
      returnTarget {
        userId
        displayName
        role
        deviceId
        isCurrentUser
      }
      request {
        requestedAt
        user {
          userId
          displayName
          role
          deviceId
          isCurrentUser
        }
      }
    }
  }
`;

export const RELEASE_SCENARIO_EDIT_LOCK_MUTATION = `
  mutation ReleaseScenarioEditLock($scenarioName: String!) {
    releaseScenarioEditLock(scenarioName: $scenarioName) {
      scenarioName
      lockActive
      canEdit
      isEditor
      currentVersion
      activeViewerCount
      otherViewerCount
      collaborationActive
      canTakeOver
      canRequestAccess
      canApproveRequest
      requestPendingForCurrentUser
      readOnlyReason
      releasePending
      releasePendingForCurrentUser
      requestDeniedForCurrentUser
      requestDeniedReason
      heartbeatExpiresAt
      editor {
        userId
        displayName
        role
        deviceId
        isCurrentUser
      }
      returnTarget {
        userId
        displayName
        role
        deviceId
        isCurrentUser
      }
      request {
        requestedAt
        user {
          userId
          displayName
          role
          deviceId
          isCurrentUser
        }
      }
    }
  }
`;

export const SET_SCENARIO_RELEASE_PENDING_MUTATION = `
  mutation SetScenarioReleasePending($scenarioName: String!, $active: Boolean!) {
    setScenarioReleasePending(scenarioName: $scenarioName, active: $active) {
      scenarioName
      lockActive
      canEdit
      isEditor
      currentVersion
      activeViewerCount
      otherViewerCount
      collaborationActive
      canTakeOver
      canRequestAccess
      canApproveRequest
      requestPendingForCurrentUser
      readOnlyReason
      releasePending
      releasePendingForCurrentUser
      requestDeniedForCurrentUser
      requestDeniedReason
      heartbeatExpiresAt
      editor {
        userId
        displayName
        role
        deviceId
        isCurrentUser
      }
      returnTarget {
        userId
        displayName
        role
        deviceId
        isCurrentUser
      }
      request {
        requestedAt
        user {
          userId
          displayName
          role
          deviceId
          isCurrentUser
        }
      }
    }
  }
`;

export const REQUEST_SCENARIO_EDIT_ACCESS_MUTATION = `
  mutation RequestScenarioEditAccess($scenarioName: String!) {
    requestScenarioEditAccess(scenarioName: $scenarioName) {
      scenarioName
      lockActive
      canEdit
      isEditor
      currentVersion
      activeViewerCount
      otherViewerCount
      collaborationActive
      canTakeOver
      canRequestAccess
      canApproveRequest
      requestPendingForCurrentUser
      readOnlyReason
      releasePending
      releasePendingForCurrentUser
      heartbeatExpiresAt
      editor {
        userId
        displayName
        role
        deviceId
        isCurrentUser
      }
      returnTarget {
        userId
        displayName
        role
        deviceId
        isCurrentUser
      }
      request {
        requestedAt
        user {
          userId
          displayName
          role
          deviceId
          isCurrentUser
        }
      }
    }
  }
`;

export const RESPOND_SCENARIO_EDIT_ACCESS_REQUEST_MUTATION = `
  mutation RespondScenarioEditAccessRequest($scenarioName: String!, $approve: Boolean!, $deniedReason: String) {
    respondScenarioEditAccessRequest(scenarioName: $scenarioName, approve: $approve, deniedReason: $deniedReason) {
      scenarioName
      lockActive
      canEdit
      isEditor
      currentVersion
      activeViewerCount
      otherViewerCount
      collaborationActive
      canTakeOver
      canRequestAccess
      canApproveRequest
      requestPendingForCurrentUser
      readOnlyReason
      releasePending
      releasePendingForCurrentUser
      requestDeniedForCurrentUser
      requestDeniedReason
      heartbeatExpiresAt
      editor {
        userId
        displayName
        role
        deviceId
        isCurrentUser
      }
      returnTarget {
        userId
        displayName
        role
        deviceId
        isCurrentUser
      }
      request {
        requestedAt
        user {
          userId
          displayName
          role
          deviceId
          isCurrentUser
        }
      }
    }
  }
`;
